import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";
import {CommonResponseModel, StockTransferDto } from "@project-management-system/shared-models";
export class StockTransferService extends CommonAxiosService{

    URL ="/stock-transfer";

    async createStockTransfer(req: StockTransferDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/createStockTransfer', req)
    }

    async CreateNegativeStock(req: StockTransferDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/CreateNegativeStock', req)
    }
    async getStockTransfers(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getStockTransfers')
    }
    async getStockNegatives(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getStockNegatives')
    }
    async receiveStock(req:any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/receiveStock',req)
    }

}
